import { Box, BoxProps } from "@chakra-ui/react";
import { TopNoticeEllipseIcon } from "./topNoticeEllipseIcon";
import { BelowNoticeEllipseIcon } from "./belowNoticeEllipseIcon";

export function NoticeIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box position="relative" {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.99999 1.83398C5.50399 1.83398 3.48341 3.85026 3.48341 6.33398V6.33403C3.48335 7.05565 3.44776 7.8651 2.93739 8.61679L2.9358 8.61913L2.93579 8.61913C2.85188 8.74122 2.77822 8.84131 2.70879 8.93565C2.61631 9.06131 2.53133 9.17677 2.43963 9.32046C2.29747 9.54321 2.2093 9.73623 2.18089 9.92247C2.08892 10.5254 2.47346 11.0024 3.14605 11.281C5.9987 12.4628 10.0013 12.4628 12.8539 11.281C13.5265 11.0024 13.9111 10.5254 13.8191 9.92247L14.3134 9.84707L13.8191 9.92247C13.7907 9.73623 13.7025 9.54321 13.5604 9.32046C13.4687 9.17677 13.3837 9.06131 13.2912 8.93565C13.2218 8.84131 13.1481 8.74123 13.0642 8.61913L13.0626 8.61679C12.5522 7.8651 12.5166 7.05565 12.5166 6.33403V6.33398C12.5166 3.85026 10.496 1.83398 7.99999 1.83398ZM2.48341 6.33394C2.48343 3.29484 4.95484 0.833984 7.99999 0.833984C11.0452 0.833984 13.5166 3.29486 13.5166 6.33398H13.0166H13.5166C13.5166 7.04093 13.5641 7.57441 13.8892 8.05397C13.9344 8.11967 13.9943 8.20196 14.0599 8.29187C14.1737 8.44807 14.3043 8.62727 14.4033 8.78248C14.5781 9.05641 14.7489 9.38675 14.8077 9.77167C14.9992 11.0275 14.1161 11.8406 13.2367 12.2049C10.139 13.4881 5.86103 13.4881 2.76334 12.2049C1.88385 11.8406 1.00076 11.0275 1.19233 9.77166C1.25104 9.38675 1.42185 9.05641 1.59667 8.78248C1.69573 8.62727 1.82631 8.44807 1.94013 8.29187C2.00567 8.20193 2.06565 8.11962 2.11085 8.05391C2.43593 7.57438 2.48335 7.04088 2.48341 6.33398"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.20491 12.1849C5.47179 12.1139 5.74564 12.2728 5.81656 12.5397C6.06292 13.4667 6.93949 14.1681 8 14.1681C9.06051 14.1681 9.93708 13.4667 10.1834 12.5397C10.2544 12.2728 10.5282 12.1139 10.7951 12.1849C11.062 12.2558 11.2208 12.5296 11.1499 12.7965C10.7849 14.1698 9.50545 15.1681 8 15.1681C6.49455 15.1681 5.21506 14.1698 4.85011 12.7965C4.77918 12.5296 4.93803 12.2558 5.20491 12.1849Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
